const petlabUser = "@thepetlabco.com";
const testUser = "@test.com";

export const isPetlabUser = (userEmail: string) => userEmail.includes(petlabUser) || userEmail.includes(testUser);
